/**
 * @generated SignedSource<<850d289280dc642fb3f14c713062cbdc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PLUEANType = "CODE128" | "CODE39" | "EAN";
export type PLUCreateProductInput = {
  active?: boolean | null;
  eanCode?: string | null;
  eanType?: PLUEANType | null;
  imageId?: string | null;
  pluCode?: string | null;
  title: string;
};
export type PLUProductCreateMutation$variables = {
  id: string;
  input: PLUCreateProductInput;
};
export type PLUProductCreateMutation$data = {
  readonly pluCategory: {
    readonly createProduct: {
      readonly category: {
        readonly id: string;
        readonly products: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PLUProductItem_PLUProduct">;
        }>;
      };
      readonly eanCode: string | null;
      readonly eanType: string;
      readonly id: string;
      readonly image: {
        readonly id: string;
      } | null;
      readonly pluCode: string | null;
      readonly title: string;
    } | null;
  } | null;
};
export type PLUProductCreateMutation = {
  response: PLUProductCreateMutation$data;
  variables: PLUProductCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eanCode",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eanType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pluCode",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "image",
  "plural": false,
  "selections": [
    (v3/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PLUProductCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PLUProduct",
            "kind": "LinkedField",
            "name": "createProduct",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUProduct",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "PLUProductItem_PLUProduct"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PLUProductCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PLUCategoryMutation",
        "kind": "LinkedField",
        "name": "pluCategory",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "PLUProduct",
            "kind": "LinkedField",
            "name": "createProduct",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PLUCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PLUProduct",
                    "kind": "LinkedField",
                    "name": "products",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v7/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "active",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PLUCategory",
                        "kind": "LinkedField",
                        "name": "category",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "color",
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "imageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "image",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ImageSize",
                            "kind": "LinkedField",
                            "name": "sizes",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "width",
                                "storageKey": null
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "url",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlExpiresAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "height",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbhash",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "079ed53cefcef19e0f385b3965601f36",
    "id": null,
    "metadata": {},
    "name": "PLUProductCreateMutation",
    "operationKind": "mutation",
    "text": "mutation PLUProductCreateMutation(\n  $id: ID!\n  $input: PLUCreateProductInput!\n) {\n  pluCategory(id: $id) {\n    createProduct(input: $input) {\n      id\n      title\n      eanCode\n      eanType\n      pluCode\n      image {\n        id\n      }\n      category {\n        id\n        products {\n          ...PLUProductItem_PLUProduct\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment PLUProductItemBody_PLUProduct on PLUProduct {\n  id\n  title\n  active\n  category {\n    ...PLUProductItemCategoryTag_PLUCategory\n    id\n  }\n  imageUrl\n  image {\n    id\n    sizes {\n      width\n      id\n    }\n    ...Image_image\n  }\n}\n\nfragment PLUProductItemCategoryTag_PLUCategory on PLUCategory {\n  id\n  color\n  title\n}\n\nfragment PLUProductItemFooter_PLUProduct on PLUProduct {\n  pluCode\n  eanCode\n  eanType\n}\n\nfragment PLUProductItem_PLUProduct on PLUProduct {\n  id\n  ...PLUProductItemFooter_PLUProduct\n  ...PLUProductItemBody_PLUProduct\n}\n"
  }
};
})();

(node as any).hash = "a4c4548e5d7326c8d2e259510392f0a2";

export default node;
